import {
  Calendar,
  ChatBubble,
  HeartPalpitation,
  HealthTest,
  Home,
  Paper,
  QuestionMark,
  Search,
} from '../../components/icons'
import {
  useIsFeatureEnabled,
  useIsScreeningDue,
  useSelectUserGender,
  useSelectUserIsInvited,
  useSelectUserMarket,
} from '../../state/selectors'
import { FeatureFlagId } from '../../api/ester-b2b-api/private/featureFlags/types'
import { useUnreadCaseMessagesCount } from '../../api/ester-b2b-api/private/case/caseQueries'
import { MenuItem } from './types'
import { isHealthCallsEnabled } from '../market'
import { Gender } from '../../api/ester-b2b-api/private/users/types'

export const useEmployeeMenu = (t: (key: string) => string): MenuItem[] => {
  const isPortalChatEnabled = useIsFeatureEnabled(FeatureFlagId.USE_PORTAL_CHAT)
  const isScreeningDue = useIsScreeningDue()
  const userMarket = useSelectUserMarket()
  const isInvited = useSelectUserIsInvited()
  const isMaleUser = useSelectUserGender() === Gender.M

  const { data: unreadCount } = useUnreadCaseMessagesCount()

  return [
    { name: t('common.navigation.home'), path: '/portal', icon: Home },
    ...(isMaleUser
      ? []
      : [{ name: t('common.navigation.yourHealth'), path: '/portal/your-health/health-plan', icon: HeartPalpitation }]),
    ...(isScreeningDue
      ? [{ name: t('common.navigation.screening'), path: '/portal/health-services/screening', icon: HealthTest }]
      : []),
    ...(isHealthCallsEnabled(userMarket, isInvited, isMaleUser)
      ? [
          {
            name: t('common.navigation.healthCalls'),
            path: '/portal/health-services/health-consultation',
            icon: Calendar,
          },
        ]
      : []),
    ...(isPortalChatEnabled
      ? [
          {
            name: t('common.navigation.messages'),
            path: '/portal/messages',
            icon: ChatBubble,
            badgeCount: unreadCount,
          },
        ]
      : []),
    { name: t('common.navigation.training'), path: '/portal/training', icon: Paper },
    { name: t('common.navigation.knowledgeBank'), path: '/portal/resource-center', icon: Search },
    { name: t('common.navigation.support'), path: '/portal/support', icon: QuestionMark },
  ]
}
